// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSectionDivider_root"};